import { render } from "./ForgotPasswordModal.vue?vue&type=template&id=6d73f3bc&scoped=true"
import script from "./ForgotPasswordModal.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordModal.vue?vue&type=script&lang=js"

import "./ForgotPasswordModal.vue?vue&type=style&index=0&id=6d73f3bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d73f3bc"]])

export default __exports__